import translate from '@translate';
import React, { FC, ReactNode, useEffect, useState } from 'react';
import { ClaimIcon, ReturnIcon } from 'src/components/SkladonIcon/SmallIcons';
import StatusLabel from 'src/components/StatusLabel';
import TableSimple from 'src/components/TableSimple';
import Typography from 'src/components/Typography';
import { sizes } from 'src/themes/default';
import { ConstantsCodesObjectType, ConstantsCodeType } from 'src/types/constantsCodes';
import { OrderClaimsReturnsType } from 'src/types/orderDetail';
import { TableColumnType, TableRowType } from 'src/types/table';
import { claimsReturnsAllColumns } from './constants';

export interface ClaimsReturnsTablePropsType {
    data?: OrderClaimsReturnsType[] | null;
    orderClaimReturnTypeCodes: ConstantsCodeType[];
    claimStatusCodesObject: ConstantsCodesObjectType;
    returnStatusCodesObject: ConstantsCodesObjectType;
}

interface ClaimsReturnsRowType extends OrderClaimsReturnsType {
    statusColor?: string;
}

const ClaimsReturnsTable: FC<ClaimsReturnsTablePropsType> = (props) => {
    const [data, setData] = useState<ClaimsReturnsRowType[] | null>(null);

    useEffect(() => {
        if (props.data) {
            setData(
                props.data.map((item) => {
                    const statusOption =
                        item.type === 'claim'
                            ? props.claimStatusCodesObject[item.STATUS || '']
                            : props.returnStatusCodesObject[item.STATUS || ''];
                    return {
                        ...item,
                        STATUS: statusOption?.label,
                        statusColor: statusOption?.color,
                    };
                })
            );
        }
    }, [props.data, props.claimStatusCodesObject, props.returnStatusCodesObject]);

    const customRender = (column: TableColumnType, row: TableRowType): ReactNode => {
        if (column.key === 'STATUS') {
            return <StatusLabel label={row.STATUS} color={row.statusColor} />;
        }
        return row[column.key];
    };

    if (!data?.length) {
        return (
            <Typography variant="h2" align="center" sx={{ marginTop: sizes.blocks_top_MG }}>
                {translate('orderDetail.emptyData')}
            </Typography>
        );
    }

    return (
        <TableSimple
            rowIdKey="typeId"
            rows={data || []}
            columsLabelPrefix="orderDetail.claimsReturnsTable"
            allColumns={claimsReturnsAllColumns}
            initSort={{ column: 'typeId', direction: 'DESC' }}
            selectOptions={{
                orderClaimReturnTypeCodes: props.orderClaimReturnTypeCodes,
            }}
            customRender={customRender}
            rowActions={[
                {
                    icon: <ClaimIcon />,
                    label: translate('orderDetail.action.claimDetail'),
                    getLink: (row) => `/claims/${row.ID}/`,
                    hiddenFce: (row) => row.type !== 'claim',
                },
                {
                    icon: <ReturnIcon />,
                    label: translate('orderDetail.action.returnDetail'),
                    getLink: (row) => `/returns/${row.ID}/`,
                    hiddenFce: (row) => row.type !== 'return',
                },
            ]}
            heightVariant="top-tab"
        />
    );
};

export default ClaimsReturnsTable;
